export default __webpack_public_path__ + "static/media/X_sound.0c446669.mp3";